<div class="card">
  <div class="card__title">
    <i class="fa-regular fa-lightbulb"></i>
    <div>{{ selectedDataLabel }}</div>
    <button class="btn btn--icon" (click)="onCloseClick()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="card__body">
    <p-table
      [value]="data"
      [autoLayout]="true"
      [scrollable]="true"
      styleClass="table--detail mt-2 mb-4"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="user.name">
            People
            <p-sortIcon field="user.name"></p-sortIcon>
          </th>
          <th pSortableColumn="knowledge">
            C
            <p-sortIcon field="knowledge"></p-sortIcon>
          </th>
          <th pSortableColumn="like">
            I
            <p-sortIcon field="like"></p-sortIcon>
          </th>
          <th pSortableColumn="teaching_learning">
            F
            <p-sortIcon field="teaching_learning"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>
            <div class="align-items-center flex gap-3 hstack">
              <div
                class="user-propic"
                [ngStyle]="{
                  'background-image': rowData.user.image
                    ? 'url(data:image/png;base64,' + rowData.user.image + ')'
                    : 'none'
                }"
              >
                <span *ngIf="!rowData.user.image">
                  {{ getInitials(rowData.user.name) }}
                </span>
              </div>
              <div class="hstack">
                <div class="cell-username">{{ rowData.user.name }}</div>
              </div>
            </div>
          </td>
          <td>
            <div class="p-badge__wrap">
              <div
                class="p-badge p-badge-circle"
                [ngClass]="getColor('knowledge', rowData.knowledge)"
              >
                <i
                  tooltipPosition="top"
                  pTooltip="{{ getTooltipLabel('knowledge', rowData.knowledge) }}"
                  class="fa-solid"
                  [ngClass]="getIcon('knowledge', rowData.knowledge)"
                ></i>
              </div>
            </div>
          </td>
          <td>
            <div class="p-badge__wrap">
              <div
                class="p-badge p-badge-circle"
                [ngClass]="getColor('like', rowData.like)"
              >
                <i
                  tooltipPosition="top"
                  pTooltip="{{ getTooltipLabel('like', rowData.like) }}"
                  class="fa-solid"
                  [ngClass]="getIcon('like', rowData.like)"
                ></i>
              </div>
            </div>
          </td>
          <td>
            <div class="p-badge__wrap">
              <div
                class="p-badge p-badge-circle"
                [ngClass]="getColor('teaching_learning', rowData.teaching_learning)"
              >
                <i
                  tooltipPosition="top"
                  pTooltip="{{ getTooltipLabel('teaching_learning', rowData.teaching_learning) }}"
                  class="fa-solid"
                  [ngClass]="getIcon('teaching_learning', rowData.teaching_learning)"
                ></i>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <table class="table--detail mt-2">
      <thead>
      <tr>
        <th>Teams</th>
      </tr>
      </thead>
      <tbody>
        @for (row of teamSkillData?.teams; track row) {
          <tr>
            <td>
              <div class="align-items-center flex gap-3 hstack">

                <div class="hstack">
                  <div class="cell-username">{{ row }}</div>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

  </div>
</div>
